var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"md":"2"}},[_c('b-card-text',[_vm._v(_vm._s(_vm.title))])],1),_c('b-col',{attrs:{"md":"9"}},[_c('b-form-row',[_vm._t("row-content")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }